(ns com.theplantscape.web-ui.tailwind.grids)

(defn grid-layout [size items]
  (into [:div.grid.grid-cols-1.gap-4.md:grid-cols-3]
        (concat
         (mapv (fn [item] [:div.w-full.bg-tps-secondary.rounded-2xl.overflow-hidden item]) (take size items))
         (mapv (fn [item] [:div.bg-tps-secondary.rounded-2xl.overflow-hidden item]) (drop size items)))))

(defn grid-layout-one [size content items]
  (into [:div.grid.grid-cols-1.gap-4.md:grid-cols-3]
        (concat
         (mapv (fn [item] [:div.w-full.bg-tps-secondary.rounded-2xl.overflow-hidden item]) (take size items))
         [[:div.md:col-span-3.w-full.bg-tps-primary.overflow-hidden #_.rounded-3xl content]]
         (mapv (fn [item] [:div.bg-tps-secondary.rounded-2xl.overflow-hidden item]) (drop size items)))))
